import React from 'react';
import { Tag } from 'antd';
import { WhatsNewEntry } from '@src/dtos/whats-new.dto';
import Slide33 from '@svg/whats-new-slide-3.3.svg?react';
import Slide33_1 from '@svg/whats-new-slide-3.3-1.svg?react';
import Slide32 from '@svg/whats-new-slide-3.2.svg?react';
import Slide321 from '@svg/whats-new-slide-3.2.1.svg?react';

/**
 * Static list of What's New entries — newest first.
 * Update this file on every release with user-visible changes.
 * All version strings are static literals (not fetched from SystemConfiguration).
 */
export const WHATS_NEW_ENTRIES: readonly WhatsNewEntry[] = [
  {
    version: '3.3',
    releaseDate: '2026-06-28',
    previewDescription:
      <ol>
        <li>Now you can leverage Smart Protection any time when building or revising a policy. Just go to Policy settings.</li>
        <li>Meet Andi! Your Dynamic Defense AI assistant that makes network protection even simpler.</li>
      </ol>,
    releaseNotesUrl: 'https://kb-dynamicdefense.att.com/attdd/docs/release3_3',
    slides: [
      {
        headline: `Smart Protection, any time`,
        description:
          `Now you can leverage Smart Protection any time when building or revising a policy. Just go to Policy settings.`,
        ImageComponent: Slide33,
      },
      {
        headline: `Meet Andi!`,
        description:
          `Your Dynamic Defense AI assistant that makes network protection even simpler.`,
        ImageComponent: Slide33_1,
      }
    ],
  },
  {
    version: '3.2.1',
    releaseDate: '2026-05-18',
    previewDescription:
      'Gain network insights from seeing common AI app usage and control AI traffic with ease under the Apps screen.',
    releaseNotesUrl: 'https://kb-dynamicdefense.att.com/attdd/docs/release3_2',
    slides: [
      {
        headline: <>Control AI app traffic <Tag color="default" className="whats-new-detail-modal__premium-badge">PREMIUM</Tag></>,
        description:
          'Gain network insights from seeing common AI app usage and control AI traffic with ease under the Apps screen.',
        ImageComponent: Slide321,
      },
    ],
  },
  {
    version: '3.2',
    releaseDate: '2026-04-12',
    previewDescription:
      'Receive a weekly or monthly executive summary report with key security activity, trends, and highlights.',
    releaseNotesUrl: 'https://kb-dynamicdefense.att.com/attdd/docs/release3_2',
    slides: [
      {
        headline: 'Security insights delivered to your inbox',
        description:
          'Receive a weekly or monthly executive summary report with key security activity, trends, and highlights.',
        ImageComponent: Slide32,
      },
    ],
  },
];
